'use client';

import { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import {
    assignedUsersThunk,
    createGroupThunk,
    getGroupsThunk,
    getGroupUsersThunk,
    getMessagesThunk,
    getUsersThunk
} from "./redux/chatBortSlice";
import { ChatList, ChatWindow, SocketConnector } from "chatbortui";
import LocalStorage from "../../utilities/localStorage";
import "../../assets/chatbort.css"; // <-- IMPORTANT: include custom CSS
import { ChatButton } from "../../common/sharedComponents/ChatComponent";
import { socketUrl } from "../../utilities/apiClient";

export default function ChatBort() {
    const dispatch = useDispatch();
    console.log("ChatBort component rendered");
    const [showChatList, setShowChatList] = useState(false);
    const [currentChat, setCurrentChat] = useState(null);
    const socketRef = useRef(null);

    const loggedUser = LocalStorage.getItem("tata_login_user");
    const currentUserId = loggedUser?.user_id;
    const currentUserName = loggedUser?.first_name;

    const handleToggleChatList = () => {
        setShowChatList(!showChatList);
        setCurrentChat(null);
    };

    const handleSelectChat = (id, type, name) => {
        setCurrentChat({ id, type, name });
        setShowChatList(false);
    };

    const handleCloseChat = () => setCurrentChat(null);
    const handleMinimizeChat = () => {
        setShowChatList(true);
        setCurrentChat(null);
    };

    const handleEditMessage = (messageId, newText) => {
        if (!currentChat || !socketRef.current) return;

        socketRef.current.emit("handleEditMessage", {
            messageId,
            messageText: newText,
            fromUserId: currentUserId,
            ...(currentChat.type === "group"
                ? { groupId: currentChat.id }
                : { toUserId: currentChat.id })
        });
    };

    const handleDeleteMessage = (messageId) => {
        if (!currentChat || !socketRef.current) return;

        socketRef.current.emit("handleDeleteMessage", {
            messageId,
            fromUserId: currentUserId,
            ...(currentChat.type === "group"
                ? { groupId: currentChat.id }
                : { toUserId: currentChat.id })
        });
    };

    const getAllUsers = async (params) => {
        let data = await dispatch(getUsersThunk(params));
        data = data?.payload;
        return data;
    };
    const getAllGroups = async (params) => {
        let data = await dispatch(getGroupsThunk(params));
        data = data?.payload;
        return data;
    };
    let socket = new SocketConnector({
        Socket_URL: socketUrl,
    });
    socket = socket.getSocket();
    const getMessages = async (payload) => {
        let data = await dispatch(getMessagesThunk(payload))
        data = data?.payload;
        return data;
    };
    const createGroup = async (payload) => {
        let data = await dispatch(createGroupThunk(payload));
        data = data?.payload;
        return data;
    };
    const getGroupUsersData = async (payload) => {
        let data = await dispatch(getGroupUsersThunk(payload));
        data = data?.payload;
        return data;
    };
    const assignedUsers = async (payload) => {
        let data = await dispatch(assignedUsersThunk(payload));
        data = data?.payload;
        return data;
    }
    return (
        <>
            <div className="chatbort-container">

                {/* CHAT BUTTON */}
                <ChatButton onClick={handleToggleChatList} />
                {/* CHAT LIST SIDEBAR */}
                {showChatList && (
                    <ChatList
                        getAllUsers={getAllUsers}
                        getAllGroups={getAllGroups}
                        onClose={handleToggleChatList}
                        onSelectChat={handleSelectChat}
                        assignedUsers={assignedUsers}
                        createGroup={createGroup}
                        socket={socket}
                        currentUserId={currentUserId}
                        currentUserName={currentUserName}
                        getGroupManageUsers={getGroupUsersData}
                    />
                )}

                {/* CHAT WINDOW */}
                {currentChat && (
                    <ChatWindow
                        chatId={currentChat.id}
                        chatType={currentChat.type}
                        getMessages={getMessages}
                        approachName={currentChat?.name}
                        onClose={handleCloseChat}
                        onMinimize={handleMinimizeChat}
                        onEditMessage={handleEditMessage}
                        onDeleteMessage={handleDeleteMessage}
                        currentUserId={currentUserId}
                        currentUserName={currentUserName}
                        socket={socket}
                    />
                )}
            </div>
        </>
    );
}
